import React from 'react';
import './Privacy.css';

const Privacy: React.FC = () => {
  return (
    <div className="privacy-page">
      <div className="container">
        <div className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: October 19, 2025</p>
        </div>

        <div className="privacy-content">
          <section className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Baseline Racquets Consultants of America ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services.
            </p>
            <p>
              Please read this Privacy Policy carefully. If you do not agree with the terms of this Privacy Policy, please do not access the site or use our services.
            </p>
          </section>

          <section className="privacy-section">
            <h2>2. Information We Collect</h2>
            
            <h3>2.1 Personal Information</h3>
            <p>We may collect personal information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register on our website</li>
              <li>Express an interest in obtaining information about us or our services</li>
              <li>Participate in activities on our website</li>
              <li>Contact us for any reason</li>
            </ul>
            <p>The personal information we collect may include:</p>
            <ul>
              <li>Name and contact information (email address, phone number, mailing address)</li>
              <li>Professional information (company name, job title)</li>
              <li>Payment information (processed securely through third-party payment processors)</li>
              <li>Any other information you choose to provide</li>
            </ul>

            <h3>2.2 Automatically Collected Information</h3>
            <p>We automatically collect certain information when you visit, use, or navigate our website, including:</p>
            <ul>
              <li>Log and usage data (IP address, browser type, operating system)</li>
              <li>Device information (device type, unique device identifiers)</li>
              <li>Location data (approximate location derived from IP address)</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>We use the information we collect or receive to:</p>
            <ul>
              <li>Facilitate account creation and the login process</li>
              <li>Send you marketing and promotional communications</li>
              <li>Provide, operate, and maintain our services</li>
              <li>Improve, personalize, and expand our services</li>
              <li>Understand and analyze how you use our services</li>
              <li>Develop new products, services, features, and functionality</li>
              <li>Communicate with you for customer service and support</li>
              <li>Process your transactions and manage your orders</li>
              <li>Send you administrative information and updates</li>
              <li>Prevent fraudulent transactions and protect against criminal activity</li>
              <li>Comply with legal obligations and enforce our terms and policies</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>4. Sharing Your Information</h2>
            <p>We may share your information in the following situations:</p>
            <ul>
              <li><strong>Service Providers:</strong> We may share your information with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf</li>
              <li><strong>Business Transfers:</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition</li>
              <li><strong>Legal Requirements:</strong> We may disclose your information where we are legally required to do so to comply with applicable law, governmental requests, or legal processes</li>
              <li><strong>Vital Interests:</strong> We may disclose your information where we believe it is necessary to protect your vital interests or the vital interests of any other person</li>
              <li><strong>With Your Consent:</strong> We may disclose your information for any other purpose with your consent</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>5. Cookies and Tracking Technologies</h2>
            <p>
              We may use cookies and similar tracking technologies to access or store information. Cookies are small data files placed on your device that help us improve our services and your experience.
            </p>
            <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our service.</p>
          </section>

          <section className="privacy-section">
            <h2>6. Data Security</h2>
            <p>
              We have implemented appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please note that no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.
            </p>
            <p>
              While we strive to use commercially acceptable means to protect your personal information, we cannot guarantee its absolute security.
            </p>
          </section>

          <section className="privacy-section">
            <h2>7. Data Retention</h2>
            <p>
              We will retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy, unless a longer retention period is required or permitted by law. When we have no ongoing legitimate business need to process your personal information, we will delete or anonymize it.
            </p>
          </section>

          <section className="privacy-section">
            <h2>8. Your Privacy Rights</h2>
            <p>Depending on your location, you may have the following rights regarding your personal information:</p>
            <ul>
              <li><strong>Access:</strong> Request access to your personal information</li>
              <li><strong>Correction:</strong> Request correction of inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your personal information</li>
              <li><strong>Objection:</strong> Object to the processing of your personal information</li>
              <li><strong>Data Portability:</strong> Request a copy of your personal information in a portable format</li>
              <li><strong>Withdraw Consent:</strong> Withdraw your consent at any time where we rely on consent</li>
            </ul>
            <p>To exercise these rights, please contact us using the contact information provided below.</p>
          </section>

          <section className="privacy-section">
            <h2>9. Third-Party Websites</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to review the privacy policies of any third-party sites you visit.
            </p>
          </section>

          <section className="privacy-section">
            <h2>10. Children's Privacy</h2>
            <p>
              Our services are not intended for individuals under the age of 18. We do not knowingly collect personal information from children under 18. If you become aware that a child has provided us with personal information, please contact us immediately.
            </p>
          </section>

          <section className="privacy-section">
            <h2>11. International Data Transfers</h2>
            <p>
              Your information may be transferred to and maintained on computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ. By using our services, you consent to such transfers.
            </p>
          </section>

          <section className="privacy-section">
            <h2>12. Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. The updated version will be indicated by an updated "Last Updated" date at the top of this Privacy Policy. We will notify you of any material changes by posting the new Privacy Policy on this page.
            </p>
            <p>
              We encourage you to review this Privacy Policy frequently to stay informed about how we are protecting your information.
            </p>
          </section>

          <section className="privacy-section">
            <h2>13. Contact Us</h2>
            <p>If you have questions or comments about this Privacy Policy, please contact us at:</p>
            <div className="contact-info">
              <p><strong>Baseline Racquets Consultants of America</strong></p>
              <p>Email: privacy@baselineconsulting.org</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;

